import { TypographyStyle32 } from '@cfra-nextgen-frontend/shared/src/components/Typography/StyledTypography';
import { styled } from '@mui/material';

// ─── Reused from shared (with minor override) ─────────────────────────────────

/** GraphikRegular 15px #002B5A — app title in the nav bar.
 *  Extends TypographyStyle32 (GraphikRegular 15px #222222), overrides color only. */
export const NavTitleTypography = styled(TypographyStyle32)(() => ({
    color: '#002B5A',
}));
